var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./virtualClassVisitModal.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7952c91c!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./virtualClassVisitModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/support_&_PD/components/virtualClassVisitModal.vue
// module id = 2321
// module chunks = 61